import React from 'react'
import './ReportMessage.css'
import reportIcon from '../../assets/images/report.svg'
import Mixpanel from '../../utils/mixpanel'
import { ANALYTIC_EVENTS } from '../../utils/constants'

const ReportMessage = ({
  content,
  openModal,
  authorType,
  analyticData
}) => {

  const ctaClickHandler = (e) => {
    Mixpanel.trackEvent({
      event: ANALYTIC_EVENTS.MESSAGE_CTA_CLICKED,
      data: {
        body: content.body,
        redirection: content.cta?.[0]?.value,
        ...analyticData
      }
    })
    e.preventDefault()
    openModal(content.cta[0].value)
  }
  return (
    <>
      <div className='progress-report-container'>
        <img src={reportIcon} alt='icon' className='icon' />
        <div className='vertical-line'></div>
        <p className='cta-body'> {content?.body}</p>
      </div>
      {content.cta && content.cta.length > 0 && (
        <div className="cta-container">
          <a
            href="#"
            className={`cta-button ${authorType === 'ME' ? 'me' : 'not-me'}`}
            onClick={ctaClickHandler}>
            {content.cta[0].label} →
          </a>
        </div>
      )}
    </>
  )
}

export default ReportMessage